import { fetchWithAuth } from "./modifyFetch";
import { get } from "svelte/store";
import ApiParams from "../stores/ApiParams";
import User from "../stores/User";
type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "HEAD" | "CONNECT" | "OPTIONS" | "TRACE" | "PATCH";
type fetchObjParam = {
  endpoint: string;
  queryParams?: string;
  method?: HttpMethod;
  body?: any;
  overrideBaseUrl?: string;
  headers?: Record<string, string>;
  signal?: AbortController["signal"];
};
let apiParams = get(ApiParams);
let user: User;
User.subscribe((value) => {
  user = value;
});

const fetchSelfService = async ({
  endpoint,
  queryParams = "",
  method = "GET",
  body,
  overrideBaseUrl,
  headers: restHeaders,
  signal, // New parameter for signal
}: fetchObjParam) => {
  let url = `${overrideBaseUrl ?? apiParams.baseURL}/${endpoint}${queryParams ? "?" : ""}${queryParams}`; //Removed APM specific accountNumber in params
  let headers: Record<string, string> = {
    Authorization: "Bearer " + user.jwtToken,
    "client-id": apiParams.clientId,
    "client-secret": apiParams.clientSecret,
    ...restHeaders,
  };
  if (method !== "GET" && method !== "DELETE") {
    headers["Content-Type"] = "application/json";
  }

  // Set up a timeout for the fetch request
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort("Server failed to respond in time"), 10000);

  let response;
  try {
    response = await fetchWithAuth(url, {
      method,
      headers,
      body: JSON.stringify(body),
      signal: signal ?? controller.signal, // Use the provided signal or the timeout signal
    });
    clearTimeout(timeoutId); // Clear the timeout if fetch completes in time

    if (!response.ok) {
      // return handleFailedFetch(response);
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("json") !== -1) {
      response = await response.json();
    } else if (contentType && contentType.indexOf("force-download") !== -1) {
      // Extract filename from header
      // const filename = response.headers.get("content-disposition");
      response = new File([await response.blob()], "test.xlsx");
    } else {
      response = await response.text();
    }
  } catch (err) {
    clearTimeout(timeoutId); // Clear the timeout in case of error
    return Promise.reject(err);
  }
  return response;
};

const getAllPaginatedContent = async ({
  endpoint,
  queryParams = "",
  method = "GET",
  body,
  overrideBaseUrl,
  headers,
}: fetchObjParam) => {
  let finalDataset = await fetchSelfService({
    endpoint,
    queryParams: queryParams,
    overrideBaseUrl,
    headers,
  });
  let totalPages = finalDataset.page.totalPages - 1;
  let nextPage = 1;
  while (totalPages >= nextPage) {
    nextPage++;
    const nextQuery = `${queryParams}&page=${nextPage}`;
    let response = await fetchSelfService({
      endpoint,
      overrideBaseUrl,
      queryParams: nextQuery,
      headers,
    });
    finalDataset.content = [...finalDataset.content, ...response.content];
    finalDataset.links = response.links;
    finalDataset.page = response.page;
  }
  return finalDataset;
};

const handleFailedFetch = (response: Response) => {
  if (response.status === 404) {
    return { content: [], page: { totalPage: 0, totalElements: 0 } };
  }
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    return response.json().then((err) => {
      throw err;
    });
  }
  let formattedResponse = {
    details: response,
    timestamp: new Date(),
    code: "no_code",
    error: "unknown error",
    status: "unknown status",
    message: "Error of an unknown nature.",
  };
  throw formattedResponse;
};

const uploadSelfService = async ({ endpoint, queryParams = "", method = "POST", body }: fetchObjParam) => {
  let url = `${apiParams.baseURL}/${endpoint}?account=${user.accountNumber}${queryParams}`;
  let headers = {
    Authorization: "Bearer " + user.jwtToken,
    "client-id": apiParams.clientId,
    "client-secret": apiParams.clientSecret,
  };

  let response;
  try {
    response = await fetchWithAuth(url, {
      method,
      headers,
      body: body,
    });
    if (response.ok) {
      console.log("api success");
    }
    if (!response.ok) {
      return handleFailedFetch(response);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      response = await response.json();
    } else {
      response = await response.text();
    }
  } catch (err) {
    return Promise.reject(err);
  }
  return response;
};

export { fetchSelfService, uploadSelfService, getAllPaginatedContent, handleFailedFetch };
